import React from "react";

import ImageSection from "@/components/ImageSection";

const LPImageSection = (props) => <ImageSection {...props} />;

export default LPImageSection;
